'use strict';

require("./StripHtml");
require("./Truncate");